import { render, staticRenderFns } from "./MMainFullBanner.vue?vue&type=template&id=059146c7&scoped=true&"
import script from "./MMainFullBanner.vue?vue&type=script&lang=js&"
export * from "./MMainFullBanner.vue?vue&type=script&lang=js&"
import style0 from "./MMainFullBanner.vue?vue&type=style&index=0&id=059146c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059146c7",
  null
  
)

export default component.exports